import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 名前
 */
export class Name extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): Name {
    if (!(value.length > 0)) {
      throw new Error('名前が入力されていません');
    }
    return new Name(value);
  }

  /** ラベル */
  static get label(): string {
    return 'クラス名';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return 'ひよこ組';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** キー */
  static get key(): string {
    return 'name';
  }

  /** タイプ */
  static get type(): string {
    return 'text';
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
